import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-search-filter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './search-filter.component.html'
})
export class SearchFilterComponent implements OnInit {
  @Input() data: any[] = [];
  @Input() field: string = 'name';
  @Input() label: string = 'Buscar';
  @Input() placeholder: string = 'Buscar...';

  @Output() filteredData = new EventEmitter<any[]>();
  
  searchTerm: string = '';

  ngOnInit() {
    this.emitFilteredData('');
  }

  normalize(text: string): string {
    return text ? text.normalize('NFD').replace(/\p{Diacritic}/gu, '') : '';
  }

  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchTerm = value;
    this.emitFilteredData(value);
  }

  search(): void {
    this.emitFilteredData(this.searchTerm);
  }

  private emitFilteredData(term: string): void {
    if (!term || term.trim() === '') {
      this.filteredData.emit(this.data);
      return;
    }

    const searchTerm = this.normalize(term).toLowerCase();
    const result = this.data.filter(item => {
      const fieldValue = String(item[this.field] || '');
      return this.normalize(fieldValue).toLowerCase().includes(searchTerm);
    });
    this.filteredData.emit(result);
  }
} 